export default __webpack_public_path__ + "static/plant-6a0a1a6a7cc6ab9fc616c9486a2db4c1.webp";